<div class="col-12">
  <div class="row g-3 align-items-end">
    <div class="col-12">
      <label class="form-label">Empregador existente</label>
      <app-busca-pesquisavel
        nomeCampo="buscaEmpregador"
        rotuloBuscar="Pesquisar empregador"
        [termo]="termo"
        (termoChange)="termoChange.emit($event)"
        [itens]="empregadores"
        [rotuloItem]="rotuloEmpregador"
        [detalheItem]="detalheEmpregador"
        (buscar)="buscar.emit()"
        (selecionar)="selecionar.emit($event)">
      </app-busca-pesquisavel>
    </div>
  </div>
</div>
